import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puede SAINT® ayudar si los antidepresivos no funcionaron?",
    answer:
      "SAINT® está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. Es un protocolo de TMS acelerada de cinco días con orientación por fMRI. La idoneidad la determina un psiquiatra tras una evaluación.",
  },
  {
    question: "¿Cuántos antidepresivos debo probar antes de SAINT®?",
    answer:
      "La depresión resistente al tratamiento se define como la falta de respuesta a al menos dos antidepresivos en dosis y duración adecuadas. SAINT® está indicado para adultos que no han mejorado con antidepresivos. Su psiquiatra puede determinar si es apropiado para usted.",
  },
  {
    question: "¿SAINT® es mejor que probar otro antidepresivo?",
    answer:
      "SAINT® actúa por un mecanismo distinto a los antidepresivos orales: estimulación magnética guiada por fMRI. Para quienes no han respondido a varios antidepresivos, SAINT® puede ser una opción. La decisión la toma un psiquiatra según su historial.",
  },
];

export const esCanSaintHelpAfterMeds = makeEsArticle({
  slug: "can-saint-help-if-antidepressants-didnt-work",
  title:
    "¿Puede SAINT® ayudar si los antidepresivos no funcionaron? | Neuro Wellness",
  description:
    "SAINT® está autorizado por la FDA para adultos cuya depresión no ha mejorado con antidepresivos. Cómo funciona, para quién es y qué esperar.",
  h1: "¿Puede SAINT® ayudar si los antidepresivos no funcionaron?",
  breadcrumbLabel: "SAINT® tras antidepresivos",
  shortAnswer:
    "SAINT® está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. Es un protocolo de TMS acelerada de cinco días con orientación por fMRI. Actúa por un mecanismo distinto a los antidepresivos orales: estimulación magnética del cerebro. Para quienes no han respondido a varios antidepresivos, SAINT® puede ser una opción. La idoneidad la determina un psiquiatra tras una evaluación.",
  keyTakeaways: [
    "SAINT® está autorizado por la FDA (K220177) para adultos.",
    "Está indicado para depresión que no ha mejorado con antidepresivos.",
    "Es un protocolo de cinco días con orientación por fMRI.",
    "Actúa por estimulación magnética, no por medicación oral.",
    "La idoneidad la determina un psiquiatra.",
  ],
  sections: [
    {
      heading: "Para quién es SAINT®",
      paragraphs: [
        "SAINT® está autorizado por la FDA (K220177) para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. No está indicado para ansiedad, trastorno bipolar, TEPT u otras condiciones. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
      ],
    },
    {
      heading: "Cómo funciona",
      paragraphs: [
        "SAINT® usa una resonancia magnética funcional (fMRI) para orientar la estimulación al circuito de cada persona, luego administra 50 sesiones de estimulación theta burst durante cinco días. Actúa por estimulación magnética, un mecanismo distinto a los antidepresivos orales.",
      ],
    },
    {
      heading: "Qué esperar",
      paragraphs: [
        "El tratamiento dura cinco días consecutivos, con diez sesiones por día. No requiere anestesia. Los resultados varían de una persona a otra. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
